export default __webpack_public_path__ + "static/mdrouz-efa475ad64e4a1f3162fd134a0b5257b.webp";